import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { ErrorUnion } from '../models/error-message';
import { errorOccurred } from './error-message.actions';

export const featureKey = 'errorMessage';

export interface FeatureState {
   errors: ErrorUnion[];
}

export const initialState: FeatureState = { errors: new Array<ErrorUnion>() };

export const errorMessageReducer = createReducer(
   initialState,
   onReset(initialState),
   on(errorOccurred, (state, action) => {
      return {
         ...state,
         errors: [...state.errors, action.error],
      };
   })
);
